import { Query, QueryKey, useQuery } from "@tanstack/react-query";
import { Job, JobState, JobType } from "../types/job/Job";
import {
  getJobs,
  getTranscodingJobStatus,
  getRedactionJobStatus,
  getTranscriptionJobStatus,
} from "../api/job";

export const useJobs = (customerId: string | undefined, jobType: JobType) => {
  return useQuery<Job[], Error>({
    queryKey: ["jobs"],
    queryFn: () => getJobs({ customerId, jobType }),
  });
};

export const useTranscodingPolling = (
  customerId: string | undefined,
  jobId: string | undefined
) => {
  return useQuery<JobState | undefined, Error>({
    queryKey: ["transcode-polling", jobId],
    queryFn: () => getTranscodingJobStatus({ customerId, jobId }),
    enabled: !!customerId && !!jobId,
    refetchInterval: 2000,
    refetchOnWindowFocus: false,
  });
};

export const useTranscriptionPolling = (
  customerId: string | undefined,
  jobId: string | undefined
) => {
  return useQuery<JobState | undefined, Error>({
    queryKey: ["transcription-polling", jobId],
    queryFn: () => getTranscriptionJobStatus({ customerId, jobId }),
    enabled: !!customerId && !!jobId,
    refetchInterval: refetchUntilComplete({ intervalSeconds: 2 }),
    refetchOnWindowFocus: false,
  });
};
function refetchUntilComplete({
  intervalSeconds,
}: {
  intervalSeconds: number;
}) {
  return (
    query: Query<JobState | undefined, Error, JobState | undefined, QueryKey>
  ) => {
    const jobState = query.state.data;
    if (jobState && [JobState.Complete, JobState.Error].includes(jobState)) {
      return false;
    }
    return intervalSeconds * 1000;
  };
}

export const useRedactionPolling = (
  customerId: string | undefined,
  jobId: string | undefined
) => {
  return useQuery<JobState | undefined, Error>({
    queryKey: ["redaction-polling", jobId],
    queryFn: () => getRedactionJobStatus({ customerId, jobId }),
    enabled: !!customerId && !!jobId,
    refetchInterval: refetchUntilComplete({ intervalSeconds: 2 }),
    refetchOnWindowFocus: false,
  });
};
